/**
 * Extended ViewController template
 *
 * User: lironc
 * Date: 5/26/13
 * Time: 1:19 PM
 */
define(function (require) {

    window.lpTag = window.lpTag || {};

    var TableViewController = require('web-agent-framework/TableViewController');
    var ViewController = require('web-agent-framework/ViewController');

    var FormSelectionViewController = ViewController.extend({
        ControllerName: FormSelectionViewController,

        LPViewMap: {

        },

        LPClassesMap: {
            checkbox: "lp_checkbox",
            radio: "lp_radio_button"
        },

        initialize: function (constructorData) {
            this.selectionClickedCallback = constructorData.selectionClickedCallback;
            this.modifyData = constructorData.modifyData; // TODO: This should be removed, the component should always be the one toggling.
            this.context = constructorData.context;
            this.tooltipPosition = constructorData.tooltipPosition || 'right';

            if (constructorData.selectionType === this.FormSelectionTypes.checkbox) {
                this.selectionType = this.LPClassesMap.checkbox;
                this.multiSelection = typeof constructorData.multiSelection !== "undefined" ? constructorData.multiSelection : true;
            } else if (constructorData.selectionType === this.FormSelectionTypes.radio) {
                this.selectionType = this.LPClassesMap.radio;
                this.multiSelection = typeof constructorData.multiSelection !== "undefined" ? constructorData.multiSelection : false;
            }

            this.formSelectionTable = new TableViewController({
                ControllerName :    "TableViewController(FormSelection)",
                rowTemplateFile:    "LP_form_selection_item.html",
                modelData:          constructorData.selectionOptions,
                modelPath:          constructorData.modelPath,
                dataRenderer:       this.formSelectionRenderer,
                lineClicked:        this.tableLineClicked,
                context:            this
            });
            if (constructorData.rowPrefix) {
                this.formSelectionTable.rowPrefix = constructorData.rowPrefix;
            }
            this.addViewController(this.formSelectionTable);

        },

        events: function () {},

        render: function () {}
    });

    FormSelectionViewController.prototype.FormSelectionTypes = {
        checkbox:   "checkbox",
        radio:      "radio"
    };

    FormSelectionViewController.prototype.formSelectionRenderer = {
        numberOfSections: function (data) {
            return 1;
        },
        numberOfRowsInSection: function (data, sectionIndex) {
            return data.length; // For array of arrays.
        },
        dataForSection: function (data, sectionIndex) {
            return null;
        },
        dataForRowInSection: function (data, rowIndex, sectionIndex) {
            var texts = {
                selectionType: this.selectionType,
                tooltipPosition: this.tooltipPosition,
                value: data[rowIndex].value,
                checked: data[rowIndex].checked ? "checked" : "",
                description: data[rowIndex].description || "",
                subtext: data[rowIndex].subtext || "",
                addSeperator: data[rowIndex].addSeperator ? "seperator" : "",
            };
            return texts;
        }
    };

    FormSelectionViewController.prototype.tableLineClicked = function (data) {
        if (this.modifyData) {
            if (this.multiSelection) {
                this.formSelectionTable.modelData[data.rowIndex].checked = !this.formSelectionTable.modelData[data.rowIndex].checked;
            } else {
                for (var i = 0; i < this.formSelectionTable.modelData.length; i++) {
                    this.formSelectionTable.modelData[i].checked = (data.rowIndex == i);
                }
            }
        }

        if (this.selectionClickedCallback) {
            this.selectionClickedCallback.call(this.context, data);
        }

        this.modelChanged();
    };

    FormSelectionViewController.prototype.modelChanged = function () {
        this.formSelectionTable.modelChanged();
    };

    return FormSelectionViewController;

});
